/**
 * `/reports/sales` -ийн `groups`-ыг туузан жагсаалт болгоно.
 *
 * `StoreSales`-тай ойролцоо боловч ялгаатай: тэр нь салбар сонгуулдаг
 * (дарж болно), энэ нь ЗӨВХӨН харуулна. Үнийн бүс, гараг зэрэг нь
 * шүүлтүүр болдоггүй — тэднээр жагсаалт шүүх эрхийг сервер өгдөггүй.
 *
 * ⚠️ Орлого string-ээр ирнэ. `Number()` зөвхөн эрэмбэ, туузны уртад —
 *    харуулах дүн бүр string дээрээ форматлагдана (CLAUDE.md дүрэм 3).
 */

import { formatMntShort, formatQty } from '@boots/domain';
import type { SalesReport } from '../../lib/types';
import { Meter } from '../meter';
import { Skeleton } from '../skeleton';

export function GroupBars({ groups, pending = false, empty, keepOrder = false }: {
  groups: SalesReport['groups'];
  pending?: boolean;
  empty: string;
  /**
   * `true` — серверийн эрэмбийг хадгална (гараг: Даваа→Ням).
   * Үгүй бол орлогоор буурахаар эрэмбэлнэ.
   */
  keepOrder?: boolean;
}) {
  if (pending) {
    return (
      <div className="flex flex-col gap-2.5">
        {Array.from({ length: 4 }, (_, i) => <Skeleton key={i} className="h-8 w-full" />)}
      </div>
    );
  }
  if (groups.length === 0) return <p className="text-[12.5px] text-ink-3">{empty}</p>;

  const rows = keepOrder
    ? [...groups].sort((a, b) => a.key.localeCompare(b.key))
    : [...groups].sort((a, b) => Number(b.revenueMnt) - Number(a.revenueMnt));
  const peak = Math.max(1, ...rows.map((g) => Number(g.revenueMnt)));
  const units = rows.reduce((n, g) => n + g.units, 0);

  return (
    <div className="flex flex-col gap-3">
      {rows.map((g) => (
        <div key={g.key} className="flex flex-col gap-1.5">
          <div className="flex items-baseline gap-2.5 text-[13px]">
            <span className="min-w-0 text-pretty">{g.label}</span>
            <span className="num ml-auto whitespace-nowrap text-[12px] text-ink-2">
              {formatQty(g.units)} ш
              {units > 0 ? ` · ${Math.round((g.units / units) * 100)}%` : ''}
            </span>
            <span className="num whitespace-nowrap">{formatMntShort(g.revenueMnt)}</span>
          </div>
          <Meter
            value={(Number(g.revenueMnt) / peak) * 100}
            label={`${g.label} — ${formatMntShort(g.revenueMnt)}, ${formatQty(g.units)} ширхэг`}
          />
        </div>
      ))}
    </div>
  );
}
